module.exports = __webpack_public_path__ + "media/images/placeholders/soon_en-f2120540079d605b8d416cbd06df8f13.svg";